import { Guest } from "../../AdminPanel";
import "../ModalStyles.css";
type Props = {
  token: string;
  guest?: Guest;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DeleteGuestModal = ({
  token,
  guest,
  onConfirm,
  onCancel,
}: Props) => {
  return (
    <div className="modal-overlay">
      <div className="modal">
        <p>
          ¿Estás seguro de que deseas eliminar la invitación de{" "}
          <strong>{guest?.name ?? "este invitado"}</strong>?
        </p>
        <p style={{ fontSize: "0.9rem", color: "#888" }}>Token: {token}</p>

        <div className="modal-buttons ">
          <button onClick={onConfirm} className="delete-button">
            Sí, eliminar
          </button>
          <button onClick={onCancel}>Cancelar</button>
        </div>
      </div>
    </div>
  );
};
